<template>
	<div>
		<s-crud
			ref="OrderSalesOV"
			title="Orden de venta"
			:config="config"
			:filter="filter"
			search-input
			@rowSelected="rowSelected($event)"
		>
			<template v-slot:filter>
				<v-container>
					<v-row>
						<v-col cols="12" md="2">
							<v-switch
								v-model="filter.ViewScheduled"
								label="Ver programados"
								hide-details
								:true-value="1"
								:false-value="0"
								@change="onViewScheduledChange"
								class="mt-0"
							></v-switch>
						</v-col>
						<template v-if="filter.ViewScheduled == 0">
							<v-col cols="12" md="3">
								<s-select-campaign-se 
									label="Campaña"
									v-model="CmpID"
									@datesLoaded="onCampaignDatesLoaded"
								/>
							</v-col>
							<v-col cols="12" md="3">
								<s-date label="Fecha inicio" v-model="filter.DocDateBegin"></s-date>
							</v-col>
							<v-col cols="12" md="3">
								<s-date label="Fecha fin" v-model="filter.DocDateEnd"></s-date>
							</v-col>
						</template>
						<template v-else>
							<v-col cols="12" md="3">
								<s-date label="Fecha" v-model="filter.ScheduledDate"></s-date>
							</v-col>
						</template>
					</v-row>
				</v-container>
			</template>
			<template v-slot:options>
				<v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn
						v-on="on"
						text
						black 
						small
						@click="viewPreGuide()"
						>
						<i class="fas fa-eye"></i>
						</v-btn>
					</template>
					<span>Visualizar Guía</span>
				</v-tooltip>
				<v-btn
					text
					black
					@click="openEditDialog()"
				>
					<i class="fas fa-edit"></i>
				</v-btn>
			</template>
		</s-crud>

		<v-dialog
			v-if="dialogGuide"
			v-model="dialogGuide"
		>
			<lgs-referral-guide-edit-ov
				:referralGuideSelected="saleOrderSelected"
				@closeDialogReferral="closeDialogReferral()"
				:typeGuide="5"
			></lgs-referral-guide-edit-ov>
		</v-dialog>

		<!-- Modal de Edición -->
		<sale-order-edit
			v-model="showEditDialog"
			:docEntry="saleOrderSelected.DocEntry"
			@saved="onSaleOrderSaved"
			@close="showEditDialog = false"
		/>
	</div>
</template>

<script>
	import _sSaleOrder from "@/services/ExternalTrade/SaleOrderService.js";
	import _sCompany from "@/services/General/GenCompanyService.js"
	import _sParameter from "@/services/General/ParameterService.js";
	import SaleOrderEdit from "./SaleOrderEdit.vue";
	import LgsReferralGuideEditOv from '../../Logistics/ReferralGuide/LgsReferralGuideEditOv.vue';
	import _sExtSaleOrder from "@/services/ExternalTrade/ExtSaleOrderService.js";
	
	export default {
		components: {
			SaleOrderEdit,
			LgsReferralGuideEditOv
		},
		data() {
			return {
				config: {
					model : {
						DocNum : 'ID',
						DocDate: 'date',
						U_SYP_FGUIA: 'date'
					},
					service : _sSaleOrder,
					headers : [
						{text : 'Fecha', value : 'DocDate'},
						{text : 'N° Documento', value : 'DocNum'},
						{text : 'Cod. Cliente', value : 'CardCode'},
						{text : 'Nombre Cliente', value : 'CardName'},
						{text : 'Booking No.', value : 'U_SYP_BOOKING'},
						{text : 'Area de produccion', value : 'U_SYP_AREAPROD'},
					]
				},
				filter : {
					DocDateBegin: null,
					DocDateEnd: null,
					ViewScheduled: 0,
					ScheduledDate: null
				},
				saleOrderSelected : {
					DocEntry : 0,
					DocNum : 0,
					referralGuideItems: []
				},
				showEditDialog : false,
				dialogGuide : false,
				CmpID : 0,
			}
		},

		methods: {
			closeDialogReferral()
			{
				this.dialogGuide = false;
			},

			async viewPreGuide() {
				if (!this.saleOrderSelected || !this.saleOrderSelected.DocNum) {
					this.$fun.alert('Seleccione una orden de venta', 'warning');
					return;
				}

				try {
					let response = await _sSaleOrder.searchforguidebydocnum(this.saleOrderSelected, this.$fun.getUserID());
					if (response && response.status === 200 && response.data) {
						Object.assign(this.saleOrderSelected, response.data);
						this.createStructureGuide();
						this.dialogGuide = true;
					} else {
						this.$fun.alert('No se pudo obtener la información extendida de la guía', 'error');
					}
				} catch (error) {
					console.error(error);
					this.$fun.alert('Error consultando los datos de la guía', 'error');
				}
			},

			rowSelected(rows)
			{
				if(rows.length > 0)
				{
					this.saleOrderSelected = rows[0];
					this.saleOrderSelected.DocEntry = rows[0].DocEntry;
					this.saleOrderSelected.DocNum = rows[0].DocNum;
					this.getDetailSaleOrder();
				}
			},

			openEditDialog() {
				if (this.saleOrderSelected.DocEntry) {
					this.showEditDialog = true;
				} else {
					this.$fun.alert('Seleccione una orden de venta', 'warning');
				}
			},

			onSaleOrderSaved() {
				this.$refs.OrderSalesOV.refresh();
			},

			onCampaignDatesLoaded(dates) {
				this.filter.DocDateBegin = dates.CmpBeginDate || null;
				this.filter.DocDateEnd = dates.CmpEndDate || null;
			},

			onViewScheduledChange(val) {
				const baseHeadersWithoutDate = [
					{text : 'N° Documento', value : 'DocNum'},
					{text : 'Cod. Cliente', value : 'CardCode'},
					{text : 'Nombre Cliente', value : 'CardName'},
				];

				if (val) {
					this.filter.DocDateBegin = null;
					this.filter.DocDateEnd = null;

					this.config.headers = [
						{text : 'Fecha de guia', value : 'U_SYP_FGUIA'},
						...baseHeadersWithoutDate,
						{text : 'Area de produccion', value : 'U_SYP_AREAPROD'},
						{text : 'Booking No.', value : 'U_SYP_BOOKING'},
					];
				} else {
					this.filter.ScheduledDate = null;
					
					this.config.headers = [
						{text : 'Fecha', value : 'DocDate'},
						...baseHeadersWithoutDate
					];
				}
			},

			getDetailSaleOrder()
			{
				_sExtSaleOrder
				.detailbydocentry(this.saleOrderSelected, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200)
					{
						var arrayDescription = []
						resp.data.forEach(element => {
							arrayDescription.push(element.RgdDescription);
						});

						let descriptionItem = {
							RgdDescription : arrayDescription.join("\n"),
							SecStatus : 1,
							UsrCreateID : this.$fun.getUserID(),
							UsrUpdateID	: this.$fun.getUserID(),
						}
						console.log('descriptionItem ', descriptionItem);
						this.saleOrderSelected.RegObservation =  arrayDescription.join(" ")
					}
				})
			},

			createStructureGuide()
			{
				console.log('sale order ', this.saleOrderSelected);
				this.saleOrderSelected.TypeDocumentDestination = 3;
				this.saleOrderSelected.RegDocumentNumberDestination = this.saleOrderSelected.SorRucClient;
				this.saleOrderSelected.RegBusinessNameDestination = this.saleOrderSelected.SorBusinessName;
				this.saleOrderSelected.RegStartPointAddressDestination = this.saleOrderSelected.SorPointArrivalAdress;
				this.saleOrderSelected.RegAddressArrivalPoint = this.saleOrderSelected.SorPointArrivalAdress;
				this.saleOrderSelected.RegBrandTransport = this.saleOrderSelected.SorVehicle; 
				this.saleOrderSelected.RegPlateTransport = this.saleOrderSelected.SorBrandVehicle; 
				this.saleOrderSelected.RegDriverLicenceTransport = this.saleOrderSelected.SorDriverLicense;
				this.saleOrderSelected.RegDocumentNumberTransport = this.saleOrderSelected.SorDriverLicense ? this.saleOrderSelected.SorDriverLicense.substring(1) : '';
				this.saleOrderSelected.RegConstancyInscripcionTransport = this.saleOrderSelected.SorConstancyInscription;
				this.saleOrderSelected.RegNamesDriver = this.saleOrderSelected.SorDriverShortName;
				this.saleOrderSelected.RegLastNameDriver = this.saleOrderSelected.SorDriverLastName;
				this.saleOrderSelected.RegRucTransport = this.saleOrderSelected.SorRucTransport;
				this.saleOrderSelected.RegBusinessNameTransport = this.saleOrderSelected.SorBusinessNameTransport;
				this.saleOrderSelected.RegNetWeightCargo = this.saleOrderSelected.SorWeightNet;
				this.saleOrderSelected.RegGrossWeightCargo = this.saleOrderSelected.SorWeightGross;
				
				var itemDe = {
					RgdLine : 1,
					RgdDescription :  this.saleOrderSelected.SorComments,
					RgdQuantity : this.saleOrderSelected.SorWeightNet,
					RgdTotal : this.saleOrderSelected.SorWeightNet,
					RgdUnitMeasurement : "KGM",
					TypeUnitMeasurement : 3
				}

				itemDe.SecStatus = 1;
				itemDe.UsrCreateID = this.$fun.getUserID();
				itemDe.UsrUpdateID = this.$fun.getUserID();

				this.saleOrderSelected.referralGuideItems = [];
				this.saleOrderSelected.referralGuideItems.push(itemDe)

				this.getCompany();
			},

			getCompany()
			{
				let a = {
					PrmName: "SunshineRuc"
				};
				_sParameter
				.search(a, this.$fun.getUserID())
				.then((r) => {
					var SunshineRuc = r.data.PrmValue;
					if(SunshineRuc != "")
					{
						_sCompany
						.searchbyruc(SunshineRuc, this.$fun.getUserID())
						.then(resp => {
							if(resp.status == 200)
							{
								this.saleOrderSelected.RegAddressStartPoint = resp.data.CpyAddress;
								this.saleOrderSelected.RegAddressStartPointBk = resp.data.CpyAddress;
							}
						});
					}
				});
			}
		},

	}
</script>
